const FIVE_MINUTES_IN_MILLISECONDS = 5 * 60 * 1000
const TEN_SECONDS_IN_MILLISECONDS = 10 * 1000

export const DRAFT_APPLICATION_LIST_CONFIG = {
    revalidateAll: true,
    revalidateOnFocus: true,
    refreshInterval: TEN_SECONDS_IN_MILLISECONDS,
}

// Used by useHasDrafts purely to check whether any drafts exist. No polling and
// no focus/reconnect refetch: the check runs once each time the banner mounts.
export const DRAFT_SUMMARY_CONFIG = {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
}

export const APPLICATION_LIST_CONFIG = {
    revalidateAll: true,
    revalidateOnFocus: true,
    refreshInterval: FIVE_MINUTES_IN_MILLISECONDS,
}

export const NO_REVALIDATE_CONFIG = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
}

const REVALIDATE_ON_MOUNT_CONFIG = {
    revalidateOnMount: true,
}

export const DEVICE_REFERENCE_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const NEW_VERSION_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const NEW_AMENDMENT_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const CONTINUE_DRAFT_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const SEARCH_CONFIG = {
    revalidateAll: true,
    revalidateOnFocus: true,
    refreshInterval: TEN_SECONDS_IN_MILLISECONDS,
}
